var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-full-screen-container',{staticClass:"main"},[_c('bheader',{staticClass:"bheader"}),_c('bmain',{staticClass:"bmain"}),_c('bfooter',{staticClass:"bfooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }